import { all, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

export function* getStoreById({ payload }): any {
  console.info('getStoreById api request:', payload);
  yield callAPI(payload, ActionTypes.GET_STORE_BY_ID, API.reservationAPI);
}

export default function* root(): Object {
  yield all([takeLatest(ActionTypes.GET_STORE_BY_ID_REQUEST, getStoreById)]);
}
